// extracted by mini-css-extract-plugin
export default {"backgroudColor":"Policy_backgroudColor__hxpjH"};